import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import App from './App';
import AdminDashboard from './AdminDashboard';
import UserDashboard from './UserDashboard';

// Component to check if path is admin route or dashboard route
function RouteHandler() {
  const location = useLocation();
  const isAdminPath = location.pathname.startsWith('/admin-') && location.pathname.length > 7;
  const isDashboardPath = location.pathname === '/dashboard' || location.pathname.startsWith('/dashboard/');
  
  if (isAdminPath) {
    return <AdminDashboard />;
  }
  
  if (isDashboardPath) {
    // Check if user has guest access OR is logged in with username/password
    const hasGuestAccess = sessionStorage.getItem('guest_access') === 'true';
    const hasAuthToken = localStorage.getItem('chat_auth_token');
    
    if (hasGuestAccess || hasAuthToken) {
      return <UserDashboard />;
    } else {
      // Redirect to main page if no access
      window.location.href = '/';
      return null;
    }
  }
  
  return <App />;
}

function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<RouteHandler />} />
      </Routes>
    </BrowserRouter>
  );
}

export default Router;
